import styled from "styled-components";
import { OutlineButtonContainer } from "@pages/casino/assets/styles/mixins";

export const ShareButtonLabel = styled.span`
	@media (max-width: 767px) {
		display: none;
	}
`;

export const ShareButton = styled(OutlineButtonContainer)`
	background: transparent;
	color: #fff;
	min-width: max-content;
	white-space: nowrap;
	flex-shrink: 0;
	margin-right: -12px;

	svg {
		width: 18px;
		height: 18px;
		margin-right: 6px;
		flex-shrink: 0;
	}

	@media (max-width: 767px) {
		width: 30px;
		min-width: 30px;
		height: 30px;
		padding: 6px;
		border-radius: 25px;
		border: 1px solid var(--secondary-text-color);
		justify-content: center;
		margin-right: -6px;

		svg {
			width: 16px;
			height: 16px;
			margin-right: 0;
		}
	}
`;
